import api from "./api";

// Función auxiliar para parsear JSON desde un Blob
async function parseJsonFromBlob(blob) {
  return new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.onload = () => {
      try {
        resolve(JSON.parse(reader.result));
      } catch (e) {
        reject(e);
      }
    };
    reader.onerror = reject;
    reader.readAsText(blob);
  });
}

export const fetchQuejas = async (page = 0, size = 10, anio = null, mes = null, atendido = null,searchTerm = "",) => {
  try {
    let url = `quejas/list`;
    const params = {
      page,
      size,
      anio,
      mes,
      atendido,
      searchTerm,
    };

    if (anio) {
      params.anio = anio;
    }
    if (mes) {
      params.mes = mes;
    }
    if (atendido) {
      params.atendido = atendido;
    }
    if (searchTerm) {
      params.folio = searchTerm;
    }

    const response = await api.get(url, {
      params,

    });

    return response.data;
  } catch (error) {
    console.error('Error:', error.response?.data || error.message);
    return { content: [], totalPages: 0, totalElements: 0 };
  }
};
// Obtener Quejas por ID
export const fetchQuejaById = async (id) => {
  try {
    const response = await api.get(`quejas/${id}`, {

    });
    return response.data;
  } catch (error) {
    console.error(`Error obteniendo queja con ID ${id}:`, error);
    throw error;
  }
};
// Reporte Excel General
export const generateExcelReport = async ({ fechaInicio, fechaFin, anio }) => {
  try {
    const fechaInicioFormatted = fechaInicio.split('T')[0];
    const fechaFinFormatted = fechaFin.split('T')[0];

    const response = await api.post(
      `quejas/reporte-excel`,
      {
        fechaInicio: fechaInicioFormatted,
        fechaFin: fechaFinFormatted,
        anio
      },
      {
        headers: {

          'Content-Type': 'application/json'
        },
        responseType: 'blob'
      }
    );

    // Verificar que la respuesta sea un blob válido
    if (!(response.data instanceof Blob)) {
      throw new Error('La respuesta no es un archivo válido');
    }

    return response;
  } catch (error) {
    console.error('Error generando reporte:', {
      status: error.response?.status,
      data: error.response?.data
    });

    // Si el backend devuelve un mensaje de error en formato JSON
    if (error.response?.headers?.['content-type']?.includes('application/json')) {
      const errorData = await parseJsonFromBlob(error.response.data);
      throw new Error(errorData.message || 'Error al generar el reporte');
    }

    throw new Error(error.message || 'Error al generar el reporte');
  }
};
// Reporte Excel Atendidas
export const generateExcelReportAtendidas = async ({ fechaInicio, fechaFin, anio }) => {
  try {
    // Formatear fechas según lo esperado por el backend (YYYY-MM-DD)
    const fechaInicioFormatted = fechaInicio.split('T')[0];
    const fechaFinFormatted = fechaFin.split('T')[0];

    const response = await api.post(
      `quejas/reporte-excel/atendidas`,
      {
        fechaInicio: fechaInicioFormatted,
        fechaFin: fechaFinFormatted,
        anio
      },
      {
        headers: {
          'Content-Type': 'application/json'
        },
        responseType: 'blob'
      }
    );

    // Verificar que la respuesta sea un blob válido
    if (!(response.data instanceof Blob)) {
      throw new Error('La respuesta no es un archivo válido');
    }

    return response;
  } catch (error) {
    console.error('Error generando reporte:', {
      status: error.response?.status,
      data: error.response?.data
    });

    // Si el backend devuelve un mensaje de error en formato JSON
    if (error.response?.headers?.['content-type']?.includes('application/json')) {
      const errorData = await parseJsonFromBlob(error.response.data);
      throw new Error(errorData.message || 'Error al generar el reporte');
    }

    throw new Error(error.message || 'Error al generar el reporte');
  }
};
// Reporte Excel Atendidas
export const generateExcelReportNoAtendidas = async ({ fechaInicio, fechaFin, anio }) => {
  try {
    // Formatear fechas según lo esperado por el backend (YYYY-MM-DD)
    const fechaInicioFormatted = fechaInicio.split('T')[0];
    const fechaFinFormatted = fechaFin.split('T')[0];

    const response = await api.post(
      `quejas/reporte-excel/no-atendidas`,
      {
        fechaInicio: fechaInicioFormatted,
        fechaFin: fechaFinFormatted,
        anio
      },
      {
        headers: {

          'Content-Type': 'application/json'
        },
        responseType: 'blob'
      }
    );

    // Verificar que la respuesta sea un blob válido
    if (!(response.data instanceof Blob)) {
      throw new Error('La respuesta no es un archivo válido');
    }

    return response;
  } catch (error) {
    console.error('Error generando reporte:', {
      status: error.response?.status,
      data: error.response?.data
    });

    // Si el backend devuelve un mensaje de error en formato JSON
    if (error.response?.headers?.['content-type']?.includes('application/json')) {
      const errorData = await parseJsonFromBlob(error.response.data);
      throw new Error(errorData.message || 'Error al generar el reporte');
    }

    throw new Error(error.message || 'Error al generar el reporte');
  }
};
// Estatus Atentidos
/* export const updateQuejaAtendidoStatus = async (id, atendido, notas, metodo, archivo) => {
  try {

    const response = await api.put(
      `quejas/${id}/atendido`,
      { 
        atendido: atendido,
        notas: notas,
        metodo: metodo,
      },
      {
        file: archivo
      },
      {
        headers: {
          'Content-Type': 'application/json'
        }
      }
    );

    return response.data;
  } catch (error) {
    throw new Error(error.response?.data?.message || "Error desconocido");
  }
}; */

export const updateQuejaAtendidoStatus = (id,formData) => {
  api.put(`quejas/${id}/atendido`, formData)
};


// Quejas Atendidas
export const fetchAtendidas = async () => {
  const data = await api.get(`quejas/atendidas`, {
  });

  return data;
};
// Quejas No Atendidas
export const fetchNoAtendidas = async () => {
  const data = await api.get(`quejas/no-atendidas`, {
  });

  return data;
};


// Registrar Queja
export const registrarQueja = async (data) => {
  const response = await api.post(`quejas/registro`, data, {
    headers: {
      'Content-Type': 'multipart/form-data',
    },
  });
  return response.data;
};

export const fetchEstadisticasRiesgo = async () => {
  const response = await api.get("quejas/riesgo-estadisticas");
  return response.data;
};

export async function enviarSeguimientoPorCorreo(seguimientoId) {
  if (!seguimientoId) {
    throw new Error("Falta seguimientoId");
  }

  try {
    const res = await api.post(
      `seguimiento/quejas/enviar-seguimiento/${seguimientoId}`
    );

    return res.data;
  } catch (error) {
    throw new Error(
      error.response?.data?.message ||
      error.response?.data ||
      "No se pudo enviar el correo"
    );
  }
}

// Obtener municipios
export const getMunicipios = async () => {
  const response = await api.get(`municipios`);
  return response.data;
};
// Obtener localidades por municipio
export const getLocalidadesByMunicipio = async (municipioId) => {
  const response = await api.get(`localidades/municipio/${municipioId}`);
  return response.data;
};
// Obtener lista de géneros
export const getGenero = async () => {
  const response = await api.get(`generos`);
  return response.data;
}
// Obtener actividades
export const getActividades = async () => {
  const response = await api.get(`actividades`);
  return response.data;
};
// Obtener subactividades por actividad
export const getSubactividadesByActividad = async (actividadId) => {
  const response = await api.get(`actividades/${actividadId}/subactividades`);
  return response.data;
};
// Actualizar datos usuarios
export const updateDetailUser = async (id, userData) => {
  const { data } = await api.put(`/usuarios/${id}`, userData);
  return data;
};
// listar todos los usuarios
export const fetchUsers = async (
  page,
  size,
  texto,

) => {
  const response = await api.get("/usuarios", {
    params: {
      page,
      size,
      texto,

    }
  });

  return response.data;
};
// Crear usuario
export const createUser = async (userData) => {
  const { data } = await api.post("/auth/register", userData);
  return data;
};
// User por id
export const getUserById = async (id) => {
  const { data } = await api.get(`/usuarios/${id}`);
  return data;
};
// Mimir usuario
export const DisabledUser = async (id) => {
  const { data } = await api.delete(`/usuarios/${id}`);
  return data;
};
// Activar usuario
export const ActiveUser = async (id) => {
  const { data } = await api.put(`/usuarios/activar/${id}`);
  return data;
};

/* export const descargarBannerCurso = (nombreArchivo) => {
  const url = obtenerUrlBannerCurso(nombreArchivo);
  window.open(url, "_blank", "noopener,noreferrer");
};

export const obtenerUrlBannerCurso = (nombreArchivo) => {
  return (`sidec.veracruz.gob.mx/api/seguimiento/quejas/${nombreArchivo}/evidencia`);
}; */

export const descargarBannerCurso = async (id) => {
  const response = await api.get(
  `/seguimiento/quejas/${id}/evidencia`,
  {
    responseType: "blob",
  }
);

const url = URL.createObjectURL(response.data);
window.open(url, "_blank");
};

export const DeleteDenuncia = async (id) => {
  try {
    const response = await api.delete(`/quejas/${id}`);
    return response.data;
  } catch (error) {
    throw new Error(error.response?.data?.message || 'Error al eliminar comisión');
  }
};

export const DeleteSeguimiento = async (id) => {
  try {
    const response = await api.delete(`/seguimiento/quejas/${id}`);
    return response.data;
  } catch (error) {
    throw new Error(error.response?.data?.message || 'Error al eliminar comisión');
  }
};